const BASE = 16;

export default {
  defaultPadding: BASE
};
